import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'howDoesItWorkPopup:title',
    defaultMessage: 'How does it work?',
    description: 'How does it work popup title',
  },
});
